import { trackEvent } from '../../analytics/analyticsTracker';
import type { BacktrackChangedAnswers } from '../../types/shared';

export function trackSessionSummary(
  completed: boolean,
  maxVisitedPageIndex: number,
  totalDurationMs: number,
  totalQuestionsCount: number,
  answeredQuestionsCount: number,
  skippedQuestionsCount: number,
  skippedQuestionIds: string[],
  validationErrorsCount: number,
  backtrackCount: number,
  validationHistory: Array<{
    pageIndex: number;
    errors: Record<string, string>;
    attemptNumber: number;
  }>
): void {
  trackEvent({
    eventName: 'survey_session_summary',
    metadata: {
      maxVisitedPageIndex,
      totalDurationMs,
      completed,
      totalQuestionsCount,
      answeredQuestionsCount,
      skippedQuestionsCount,
      skippedQuestionIds,
      validationErrorsCount,
      backtrackCount,
      validationHistory,
    },
  });
}

export function trackOptionalQuestionSkipped(questionId: string, pageIndex: number): void {
  trackEvent({
    eventName: 'optional_question_skipped',
    metadata: {
      questionId,
      pageIndex,
    },
  });
}

export function trackBacktrackRevisited(
  fromPageIndex: number,
  toPageIndex: number,
  changedAnswers: BacktrackChangedAnswers
): void {
  trackEvent({
    eventName: 'backtrack_revisited',
    metadata: {
      fromPageIndex,
      toPageIndex,
      changedAnswers,
    },
  });
}
